// extracted by mini-css-extract-plugin
export default {"rounded":"ImageCorners_rounded__TK6Gp","tile":"ImageCorners_tile__3wtoG","clip":"ImageCorners_clip__sjec9"};